<div class="modal fade saveAlertModal" tabindex="-1" role="dialog" id="saveAlertModal" data-backdrop="true" [attr.aria-label]="'SHARED.SAVEALERT.ARE_YOU_SURE' | translate" aria-hidden="true" cdkTrapFocus>
        <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                        <button #closeAlertModalBtn type="button" qid="save-alert-anchor-1" class="close" data-dismiss="modal" [attr.aria-label]="'SHARED.SAVEALERT.CLOSE' | translate" (click)="saveAlertActionSelection(false)">
                            <i class="nemo-font nemo-cross" aria-hidden="true"></i>
                        </button>
                        <div class="modal-header">
                                <h5 class="modal-title">{{ 'SHARED.SAVEALERT.ARE_YOU_SURE' | translate }}</h5>
                        </div>
                        <div class="modal-body pr-0 pl-0">
                                <p class="modal-desc">{{'SHARED.SAVEALERT.LOOSE_WORK_WARNING_MESSAGE' | translate }}</p>
                                <button type="button" qid="save-alert-anchor-2" class="stay-on-page-link" data-dismiss="modal"
                                         (click)="saveAlertActionSelection(false)"> {{ 'SHARED.SAVEALERT.STAY' | translate }}
                                </button>
                                <button type="button" qid="save-alert-anchor-3" data-dismiss="modal"
                                        (click)="saveAlertActionSelection(true)" class="btn btn-main-1 btn-lg p-3 mt-4"> {{ 'SHARED.SAVEALERT.EXIT' | translate }}
                                </button>
                        </div>
                </div>
        </div>
</div>